import React, { Fragment } from "react"
import classnames from "classnames"

import styles from "./styles.css"

function AutomaticDebitSkeleton() {
  return (
    <Fragment>
      <div className={styles.mainSectionSkeleton}>
        <div className={classnames(styles.sectionGeneralInformationSkeleton)}>
          <div className={classnames(styles.title, styles.skeleton)}></div>

          <div className={classnames(styles.selector, styles.skeleton)}></div>

          <div className={styles.informationContainer}>
            <div className={styles.skeleton}></div>
            <div className={styles.skeleton}></div>
            <div className={styles.skeleton}></div>
            <div className={styles.skeleton}></div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default AutomaticDebitSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/AutomaticDebitSkeleton/index.js